import React from "react";
import "../pagina-deposito/Style.css";
import Deposito from "../../components/acesso-rapido/deposito/Deposito";

export default function () {
  return <Deposito />;
}
